<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <QuestionBase>
    <template v-slot:question>
      <slot name="question">{{ updatedQuestion }}</slot>
    </template>
    <template v-slot:question-options>
      <div class="lgrm-choice-options" :class="{ 'lgrm-vertical': vertical }">
        <div v-if="type === 'RADIO'">
          <div
            class="lgrm-choice-option"
            v-for="option in options"
            :key="option.id"
          >
            <input
              type="radio"
              :value="option.id"
              v-model="selected"
              :id="'option-' + option.id"
            />
            <label :for="'option-' + option.id"> {{ option.label }}</label>
          </div>
        </div>
        <EmojiRating
          v-if="type === 'EMOJI'"
          :options="options"
          :color="color"
          :borderColor="borderColor"
          :organColor="organColor"
          :selectedValue="selected || -1"
          :readonly="readonly"
          @change="onchange"
          :disableToolTip="false"
          :animationEnabled="animationEnabled"
        ></EmojiRating>
      </div>
    </template>
  </QuestionBase>
</template>

<script >
import QuestionBase from './QuestionBase'
import EmojiRating from './question_types/EmojiRating'
import strings from '../../../../src/strings'
import colorMixin from '../../../../src/mixins/colors'
export default {
  name: 'SingleChoiceQuestion',
  mixins: [colorMixin],
  components: { QuestionBase, EmojiRating },
  props: {
    question: {
      type: String,
      default: 'Overall how satisfied are you with {brand_name}'
    },
    options: {
      type: Array,
      default: function() {
        return strings.SAT.widget_button_labels
      }
    },
    type: {
      type: String,
      default: 'EMOJI' // RADIO
    },
    brandName: String,
    value: {
      type: Number,
      default: function() {
        return 1
      }
    },
    color: { type: String, default: 'red' },
    borderColor: { type: String },
    organColor: { type: String },
    multiple: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    size: { type: Number, default: 30 },
    animationEnabled: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      selected: this.value,
      vertical: false
    }
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandName)
        return this.question.replace('{brand_name}', this.brandName)
      return this.question
    },
    ranges: function() {
      let ranges = range(this.minValue, this.maxValue + 1)
      if (this.vertical) {
        ranges.reverse()
      }
      return ranges
    }
  },
  methods: {
    onchange: function(value) {
      this.$emit('change', value)
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-choice-options {
    display: inline-block
    text-align left
    font-size 16px
    .lgrm-choice-option {
        margin-bottom 10px
    }
}
</style>
